import Vue from 'vue'
import Vuex from 'vuex'
import { axios2 as axios } from "@/interceptor/useApi";
import Swal from 'sweetalert2';

Vue.use(Vuex)

function agruparPorPareto(items, labelOtros, categoryField = 'descripcion', valueField = 'cantidad') {
  if (!items || items.length <= 5) return items || [];

  const sorted = [...items].sort((a, b) => b[valueField] - a[valueField]);
  const total = sorted.reduce((sum, item) => sum + item[valueField], 0);
  if (total === 0) return sorted;

  const threshold = total * 0.8;
  let cumulative = 0;
  const mainItems = [];
  const otherItems = [];

  for (let i = 0; i < sorted.length; i++) {
    const item = sorted[i];
    if (cumulative < threshold) {
      mainItems.push(item);
      cumulative += item[valueField];
    } else {
      otherItems.push(item);
    }
  }

  if (otherItems.length === 1) {
    return sorted;
  }

  if (otherItems.length > 1) {
    const otherSum = otherItems.reduce((sum, item) => sum + item[valueField], 0);
    // Ordenar descendente dentro de los otros para mostrar los más relevantes primero
    const sortedOthers = [...otherItems].sort((a, b) => b[valueField] - a[valueField]);

    const limit = 10;
    const itemsToShow = sortedOthers.slice(0, limit);
    const lines = itemsToShow.map(item => `  • ${item[categoryField]}: ${item[valueField]}`);

    if (sortedOthers.length > limit) {
      const remainingCount = sortedOthers.length - limit;
      lines.push(`  • y ${remainingCount} más...`);
    }

    mainItems.push({
      [categoryField]: labelOtros,
      [valueField]: otherSum,
      tooltipLines: lines
    });
    return mainItems;
  }

  return mainItems;
}

function agruparPorLimite(items, limit = 6, labelOtros, categoryField = 'descripcion', valueField = 'cantidad') {
  if (!items || items.length <= limit) return items || [];

  const sorted = [...items].sort((a, b) => b[valueField] - a[valueField]);

  const mainItems = sorted.slice(0, limit);
  const otherItems = sorted.slice(limit);

  const otherSum = otherItems.reduce((sum, item) => sum + item[valueField], 0);
  const lines = otherItems.map(item => `  • ${item[categoryField]}: ${item[valueField]}`);

  mainItems.push({
    [categoryField]: labelOtros,
    [valueField]: otherSum,
    tooltipLines: lines
  });

  return mainItems;
}

export default {
  namespaced: true,
  state: {
    Items: [],
    Marcas: [],
    CantidadMarcas: [],
    Medidas: [],
    CantidadMedidas: [],
    TooltipMedidas: [],
    CondicionNeumaticos: [],
    CantidadxCondicionNeumaticos: [],
    Estados: [],
    CantidadEstados: [],
    ModelosyDisenios: [],
    CantidadModelosyDisenios: [],
    TooltipModelosyDisenios: [],
    BackgroundModelosyDisenios: [],
    BorderModelosyDisenios: [],
    Anios: [],
    CantidadNeumaticosScrap: [],
    scrap_por_anio: [],
    scrap_por_motivo_por_anio: {},
  },
  getters: {
    Items(state) {
      return state.Items
    }
  },
  mutations: {
    LlenarItems(state, payload) {
      state.Items = payload
    },
    LlenarMarcas(state, payload) {
      state.Marcas = payload
    },
    LlenarCantidadMarcas(state, payload) {
      state.CantidadMarcas = payload
    },
    LlenarCondicionNeumaticos(state, payload) {
      state.CondicionNeumaticos = payload
    },
    LlenarCantidadxCondicionNeumaticos(state, payload) {
      state.CantidadxCondicionNeumaticos = payload
    },
    LlenarEstados(state, payload) {
      state.Estados = payload
    },
    LlenarCantidadEstados(state, payload) {
      state.CantidadEstados = payload
    },
    LlenarModelosyDisenios(state, payload) {
      state.ModelosyDisenios = payload
    },
    LlenarCantidadModelosyDisenios(state, payload) {
      state.CantidadModelosyDisenios = payload
    },
    LlenarTooltipModelosyDisenios(state, payload) {
      state.TooltipModelosyDisenios = payload
    },
    LlenarBackgroundModelosyDisenios(state, payload) {
      state.BackgroundModelosyDisenios = payload
    },
    LlenarBorderModelosyDisenios(state, payload) {
      state.BorderModelosyDisenios = payload
    },
    LlenarMedidas(state, payload) {
      state.Medidas = payload
    },
    LlenarCantidadMedidas(state, payload) {
      state.CantidadMedidas = payload
    },
    LlenarTooltipMedidas(state, payload) {
      state.TooltipMedidas = payload
    },
    LlenarAnios(state, payload) {
      state.Anios = payload
    },
    LlenarCantidadNeumaticosScrap(state, payload) {
      state.CantidadNeumaticosScrap = payload
    },
    LlenarScrapPorAnio(state, payload) {
      state.scrap_por_anio = payload
    },
    LlenarScrapPorMotivoPorAnio(state, payload) {
      state.scrap_por_motivo_por_anio = payload
    }
  },
  actions: {
    messageErrorAlert: function () {
      Swal.fire({
        title: "Upps, algo paso!",
        text: "Servidor desconectado, por favor actualice la ventana!",
        icon: "error",
        showCancelButton: false,
        confirmButtonColor: "#d33",
        confirmButtonText: "Actualizar",
        showClass: {
          popup: `
            animate__animated
            animate__fadeInUp
            animate__faster
          `,
        },
        hideClass: {
          popup: `
            animate__animated
            animate__fadeOutDown
            animate__faster
          `,
        },
        backdrop: `
          rgba(255,0,0,0.1)
          left top
          no-repeat
        `,
      }).then((result) => {
        if (result.isConfirmed) {
          location.reload();
        }
      });
    },

    datosGraficos: async function ({ commit, dispatch }) {
      const data = { id_cliente: localStorage.getItem("idcliente") };
      try {
        const url = "home/reportesvistaprincipal"
        await axios.post(url, data)
          .then(response => {
            let etiquetasmarcas = [];
            let datosmarcas = [];
            let cantidadotros = 0;
            //MARCAS
            response.data.success.marcas.forEach((element, index) => {
              if (index < 5) {
                etiquetasmarcas.push(element.descripcion);
                datosmarcas.push(element.cantidad);
              } else {
                cantidadotros += element.cantidad;
              }
            });

            if (cantidadotros > 0) {
              etiquetasmarcas.push("OTROS");
              datosmarcas.push(cantidadotros);
            }
            //CONDICION DE NEUMATICOS
            let condicion = [];
            let cantidadxcondicion = [];
            condicion.push("Nuevo");
            condicion.push("Reencauchado");
            cantidadxcondicion.push(response.data.success.cantidadnuevos);
            cantidadxcondicion.push(response.data.success.cantidadreencauchados);

            //ESTADO DE NEUMATICOS
            let etiquetasestados = [];
            let datosestados = [];
            response.data.success.estados.forEach((element, index) => {
              etiquetasestados.push(element.descripcion);
              datosestados.push(element.cantidad);
            });

            //MODELOS Y DISENIOS
            let lmodelosydisenios = [];
            let datosmodelosydisenio = [];
            let tooltipmodelosydisenio = [];
            let background = [];
            let border = [];
            const modelosAgrupados = agruparPorPareto(response.data.success.modelos, "OTROS MODELOS");
            modelosAgrupados.forEach((element, index) => {
              background.push("rgba(0, 188, 212)");
              border.push("rgba(0, 188, 212)");
              lmodelosydisenios.push(element.descripcion);
              datosmodelosydisenio.push(element.cantidad);
              tooltipmodelosydisenio.push(element.tooltipLines || null);
            });

            const diseniosAgrupados = agruparPorPareto(response.data.success.disenios, "OTROS DISEÑOS");
            diseniosAgrupados.forEach((element, index) => {
              background.push("rgba(255, 99, 132)");
              border.push("rgba(255,99,132)");
              lmodelosydisenios.push(element.descripcion);
              datosmodelosydisenio.push(element.cantidad);
              tooltipmodelosydisenio.push(element.tooltipLines || null);
            });

            //MEDIDAS
            let etiquetasmedida = [];
            let datosmedida = [];
            let tooltipmedidas = [];
            const medidasAgrupadas = agruparPorPareto(response.data.success.medidas, "OTRAS MEDIDAS");
            medidasAgrupadas.forEach((element, index) => {
              etiquetasmedida.push(element.descripcion);
              datosmedida.push(element.cantidad);
              tooltipmedidas.push(element.tooltipLines || null);
            });

            //SCRAP
            // Apply limit of 8 grouping to scrap reasons per year, rest to "OTROS MOTIVOS"
            const scrap_por_motivo_por_anio = {};
            const raw_scrap_por_motivo_por_anio = response.data.success.neumaticosscrap.scrap_por_motivo_por_anio;
            Object.keys(raw_scrap_por_motivo_por_anio).forEach(year => {
              scrap_por_motivo_por_anio[year] = agruparPorLimite(raw_scrap_por_motivo_por_anio[year], 8, "OTROS MOTIVOS", "descripcion", "cantidad");
            });

            commit('LlenarScrapPorAnio', response.data.success.neumaticosscrap.scrap_por_anio);
            commit('LlenarScrapPorMotivoPorAnio', scrap_por_motivo_por_anio);

            let etiquetasscrap = [];
            let datosscrap = [];
            response.data.success.neumaticosscrap.scrap_por_anio.forEach((element) => {
              etiquetasscrap.push(element.anio);
              datosscrap.push(element.cantidad);
            });

            //PROBAR GRAFICO DE DOS DATASET


            commit('LlenarMarcas', etiquetasmarcas);
            commit('LlenarCantidadMarcas', datosmarcas);
            commit('LlenarEstados', etiquetasestados);
            commit('LlenarCantidadEstados', datosestados);
            commit('LlenarModelosyDisenios', lmodelosydisenios);
            commit('LlenarCantidadModelosyDisenios', datosmodelosydisenio);
            commit('LlenarTooltipModelosyDisenios', tooltipmodelosydisenio);
            commit('LlenarBackgroundModelosyDisenios', background);
            commit('LlenarBorderModelosyDisenios', border);
            commit('LlenarCondicionNeumaticos', condicion);
            commit('LlenarCantidadxCondicionNeumaticos', cantidadxcondicion);
            commit('LlenarMedidas', etiquetasmedida);
            commit('LlenarCantidadMedidas', datosmedida);
            commit('LlenarTooltipMedidas', tooltipmedidas);
            commit('LlenarAnios', etiquetasscrap);
            commit('LlenarCantidadNeumaticosScrap', datosscrap);

          })
          .catch(error => {
            this.errorMessage = error.response.data;
            console.error("error!", error);
            dispatch("messageErrorAlert");
          });
      } catch (error) {
        console.log(error);
        dispatch("messageErrorAlert");
      }
    },

    cargarPlugins: async function ({ commit, dispatch }) {
      try {
        const data = { idcliente: localStorage.getItem('idclient') };
        const url = "plugin"
        await axios.post(url, data)
          .then(response => {
            commit('LlenarItems', response.data);
          })
          .catch(error => {
            this.errorMessage = error.response.data;
            console.error("There was an error!", error);
            dispatch("messageErrorAlert");
          });
      } catch (error) {
        console.log(error);
        dispatch("messageErrorAlert");
      }
    },
    Instalar: async function ({ commit, dispatch }, datos) {
      try {
        const url = "storeplugin"
        await axios.post(url, datos)
          .then(response => {
            dispatch('cargarPlugins');
          })
          .catch(error => {
            this.errorMessage = error.response.data;
            console.error("error!", error);
            dispatch("messageErrorAlert");
          });
      } catch (error) {
        console.log(error);
        dispatch("messageErrorAlert");
      }
    },
    Desinstalar: async function ({ commit, dispatch }, datos) {
      try {
        const url = "storedesplugin"
        await axios.post(url, datos)
          .then(response => {
            dispatch('cargarPlugins');
          })
          .catch(error => {
            this.errorMessage = error.response.data;
            console.error("error!", error);
            dispatch("messageErrorAlert");
          });
      } catch (error) {
        console.log(error);
        dispatch("messageErrorAlert");
      }
    }
  }

}


